export default __webpack_public_path__ + "9c8aa0dd7482c17c5a065317c8e7465f.png";